import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, ParamMap } from '@angular/router';
import { UserProfile } from 'src/app/model/user-profile';
import { of } from 'rxjs'
import { CookieService } from 'ngx-cookie';
import * as _ from 'lodash';
import { UserService, RoutesDto } from '../../commonservices/user.service';


import { filter, startWith, switchMap, distinctUntilChanged, debounceTime, mergeMap, takeUntil } from 'rxjs/operators';
import { routesCTMSFlat } from '../../ctms/ctms.module';

@Component({
  selector: 'app-sidebar',
  styleUrls: ['./sidebar.component.scss'],
  templateUrl: './sidebar.component.html'
})

export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: Array<any> = [];
  public Submenu: Array<any> = [];
  public _userProfile: UserProfile;
  private _router: Router

  currentUrl: NavigationEnd;
  parentUrl: any;
  
  @Output() onClickMenu = new EventEmitter();

  // this is for the open close
  addExpandClass(element: any) {
    // this.onClickMenu.emit(element);
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }     
  }

  addActiveClass(element: any) {
    this.showSubMenu = '0';
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  routeParent: any;

  constructor(
    private _cookieService: CookieService, 
    private _userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute ) {

      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((navs: NavigationEnd) => {
          this.showMenu = this.activatedRoute.snapshot.data['Title'];
          this.routeParent = this.createBreadCrumb(this.activatedRoute.root);        
          this.currentUrl = navs;
        });
  }

  createBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: Array<any> = []): any {
    const children: Array<ActivatedRoute> = route.children;
    if (children.length === 0) {
      return route.snapshot.data['parent'];
    }
    return this.createBreadCrumb(children[0], url, breadcrumbs);   
  }

  ngOnInit() {

    of(JSON.parse(this._cookieService.get("pages"))).subscribe((pageAccess: any) =>{
      var pages = pageAccess;
      // only show unique page strings
      pages  = [...new Set(pages)].sort();
      
      this._cookieService.put("pages", JSON.stringify(pages));
      var tempPages: Array<any> = [];
      let ctmsSubMenu = [];
      let ratedocumentSubMenu = [];

        if(pages.includes('ctms')){
          ctmsSubMenu.push({
            "Class": 'CTMS',
            "Extralink": false,
            "Icon": "mdi mdi-gauge",
            "Label": null,
            "LabelClass": null,
            "Path": "/ctms/orders",
            "Title": "Orders",
          });

          ctmsSubMenu.push({
            "Class": 'CTMS',
            "Extralink": false,
            "Icon": "mdi mdi-gauge",
            "Label": null,
            "LabelClass": null,
            "Path": "/ctms/shipments",
            "Title": "Shipments",
          });
        }

        if(pages.includes('ratesearch')){
          ctmsSubMenu.push({
            "Class": 'CTMS',
            "Extralink": false,
            "Icon": "mdi mdi-gauge",
            "Label": null,
            "LabelClass": null,
            "Path": "/ctms/ratesearch",
            "Title": "Rate Search",
          })
        }

        if(pages.includes('raterequestv2')){
          ctmsSubMenu.push({
            "Class": 'CTMS',
            "Extralink": false,
            "Icon": "mdi mdi-gauge",
            "Label": null,
            "LabelClass": null,
            "Path": "/ctms/raterequest",
            "Title": "Rate Request",
          })
        }
     

        if(ctmsSubMenu.length > 0){
          
          // Get First Available MENU in CTMS
          const [first] = ctmsSubMenu;      

          tempPages.push({
            "Class": 'CTMS',
            "Extralink": true,
            "Icon": "mdi mdi-relative-scale",
            "Label": null,
            "LabelClass": null,
            "Path": first.Path,
            "Title": "CTMS",
            "Submenu" : ctmsSubMenu
          });
        }


      if(pages.includes('ratedocument')){
        ratedocumentSubMenu.push({
          "Class": 'rate',
          "Extralink": false,
          "Icon": "mdi mdi-gauge",
          "Label": null,
          "LabelClass": null,
          "Path": "/rate-document/requests",
          "Title": "Request",
        });

        ratedocumentSubMenu.push({
          "Class": 'rate',
          "Extralink": false,
          "Icon": "mdi mdi-gauge",
          "Label": null,
          "LabelClass": null,
          "Path": "/rate-document/search",
          "Title": "Search",
        });
      }

      if(ratedocumentSubMenu.length > 0){
        const [first] = ratedocumentSubMenu;
        tempPages.push({
          "Class": 'rate',
          "Extralink": true,
          "Icon": "mdi mdi-relative-scale",
          "Label": null,
          "LabelClass": null,
          "Path": first.Path,
          "Title": "Rate-Document",
          "Submenu" : ratedocumentSubMenu
        });
      }     


      // WebResolution V2
      if(pages.includes('webresolutionv2')){
        tempPages.push({
          "Class": 'webresolution',
          "Extralink": false,
          "Icon": "mdi mdi-relative-scale",
          "Label": null,
          "LabelClass": null,
          "Path": "/webresolution/webresolutionlist",
          "Title": "Web Resolution"
        })
      }
      
      if(pages.includes('edatav2')){
        tempPages.push({
          "Class": 'eDataNew',
          "Extralink": false,
          "Icon": "mdi mdi-database",
          "Label": null,
          "LabelClass": null,
          "Path": "/eDataNew",
          "Title": "E Data"
        })
      }

      if(pages.includes('webstorev2')){
        tempPages.push({
          "Class": 'newwebstore',
          "Extralink": false,
          "Icon": "mdi mdi-store",
          "Label": null,
          "LabelClass": null,
          "Path": "/newwebstore",
          "Title": "Web Store"
        })
      }

      if(pages.includes('imagearchive')){
        tempPages.push({
          "Class": 'imagearchive',
          "Extralink": false,
          "Icon": "mdi mdi-store",
          "Label": null,
          "LabelClass": null,
          "Path": "/imagearchive",
          "Title": "Image Archive"
        })
      }

      if(pages.includes('imagearchivev2')){
        tempPages.push({
          "Class": 'newimagearchive',
          "Extralink": false,
          "Icon": "mdi mdi-store",
          "Label": null,
          "LabelClass": null,
          "Path": "/newimagearchive",
          "Title": "Image Archive"
        })
      }

      if(pages.includes('rules')){
        this.sidebarnavItems.push({
          "Class": 'Rules',
          "Extralink": true,
          "Icon": "mdi mdi-gauge",
          "Label": null,
          "LabelClass": null,
          "Path": "/rules/coding",
          "Title": "Rules",
          Submenu :
            [{
            "Class": 'Rules',
            "Extralink": false,
            "Icon": "mdi mdi-gauge",
            "Label": null,
            "LabelClass": null,
            "Path": "/rules/coding",
            "Title": "Coding",
            },
            {
              "Class": 'Rules',
              "Extralink": false,
              "Icon": "mdi mdi-gauge",
              "Label": null,
              "LabelClass": null,
              "Path": "/rules/autopass",
              "Title": "AutoPass",
            },
            {
              "Class": 'Rules',
              "Extralink": false,
              "Icon": "mdi mdi-gauge",
              "Label": null,
              "LabelClass": null,
              "Path": "/rules/invoicemanagement",
              "Title": "Invoice Mgmt",
            },
            {
              "Class": 'Rules',
              "Extralink": false,
              "Icon": "mdi mdi-gauge",
              "Label": null,
              "LabelClass": null,
              "Path": "/rules/tms",
              "Title": "TMS",
            },
            {
              "Class": 'Rules',
              "Extralink": false,
              "Icon": "mdi mdi-gauge",
              "Label": null,
              "LabelClass": null,
              "Path": "/rules/production",
              "Title": "Production",
            },
            {
              "Class": 'Rules',
              "Extralink": false,
              "Icon": "mdi mdi-gauge",
              "Label": null,
              "LabelClass": null,
              "Path": "/rules/validation",
              "Title": "Validation",
            }
          ]
        }
        
        )
      }

      // Sort Menus Alphabetically
      this.sidebarnavItems.push(..._.orderBy(tempPages,['Title']));
      this._cookieService.put("sidebarmenus", JSON.stringify(this.sidebarnavItems));

      //always dashboard menu on top of other menu
      if(pages.indexOf("ctdashboard") > -1)
      {
        this.sidebarnavItems.unshift({
          "Class": 'dashboard',
          "Extralink": false,
          "Icon": "mdi mdi-home",
          "Label": null,
          "LabelClass": null,
          "Path": "/dashboard",
          "Title": "Dashboard"
        });
      }
    });
 
  }
  
  routeChange(){
      localStorage.removeItem("__homeTempStore");
  }

  nestedActivateActive(data: any){
    return this.currentUrl.url.split('/').filter(x => x).includes(this.routeParent) && data.Title && data.Title.toLowerCase() == this.routeParent;
  }

  selectedClass: string;

  isActiveParent(data: any): boolean{
    if(data['Class'] && data['Class'].toLowerCase() == 'null') return false;
    if('Submenu' in data) return false;
    if(data['Path'] !== this.currentUrl.url) return false;    
    return this.currentUrl.url.split('/').filter(x => x).includes(data['Class'].toLowerCase());
  }
}


